// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let ReactRender = require("../../../reason/utils/ReactRender.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");
let VisuallyHidden = require("@reach/visually-hidden").default;

function PaginationBoxRefetchable$NextPrevLink(props) {
  let __hasRightBorder = props.hasRightBorder;
  let children = props.children;
  let onClick = props.onClick;
  let href = props.href;
  let hasRightBorder = __hasRightBorder !== undefined ? __hasRightBorder : false;
  let base = "w-[30px] h-[30px] shrink-0 flex justify-center items-center relative";
  let borderClass = hasRightBorder ? "border-r border-zinc-300" : "";
  if (href !== undefined) {
    return JsxRuntime.jsx("a", {
      children: children,
      className: TailwindMerge.twMerge([
        base,
        borderClass
      ]),
      href: href,
      onClick: event => {
        if (event.metaKey || event.ctrlKey) {
          return;
        } else {
          event.preventDefault();
          return onClick();
        }
      }
    });
  } else {
    return JsxRuntime.jsx("div", {
      children: children,
      "aria-disabled": true,
      className: TailwindMerge.twMerge([
        base,
        borderClass,
        "aria-disabled:opacity-30"
      ])
    });
  }
}

let NextPrevLink = {
  make: PaginationBoxRefetchable$NextPrevLink
};

function PaginationBoxRefetchable(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs(PaginationBoxRefetchable$NextPrevLink, {
        href: props.previousPagePath,
        onClick: props.onClickPrevious,
        children: [
          JsxRuntime.jsx(VisuallyHidden, {
            children: "Previous page"
          }),
          JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(IconV5.make, {
              icon: "arrow-left",
              size: 15
            }),
            "aria-hidden": true,
            className: "flex text-zinc-600"
          })
        ],
        hasRightBorder: true
      }),
      ReactRender.fromOption(props.pageInfo, param => JsxRuntime.jsx("div", {
        children: `Page ` + param.currentPage.toString() + ` of ` + param.totalPages.toString(),
        className: "h-[30px] shrink-0 flex justify-center items-center relative px-[15px] text-zinc-600 border-r border-zinc-300"
      })),
      JsxRuntime.jsxs(PaginationBoxRefetchable$NextPrevLink, {
        href: props.nextPagePath,
        onClick: props.onClickNext,
        children: [
          JsxRuntime.jsx(VisuallyHidden, {
            children: "Next page"
          }),
          JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(IconV5.make, {
              icon: "arrow-right",
              size: 15
            }),
            "aria-hidden": true,
            className: "flex text-zinc-600"
          })
        ]
      })
    ],
    className: "inline-flex justify-center items-center border border-zinc-300 rounded bg-white relative"
  });
}

let make = PaginationBoxRefetchable;

exports.NextPrevLink = NextPrevLink;
exports.make = make;
/* IconV5 Not a pure module */
